import { useState, useEffect } from 'react';
import { Button, Form } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { DropdownSelectWithLabel } from '../../../components/common/standardComponents';
import ActiveErrors from '../../../components/common/activeErrors';

import { getServicesForReferralSiteAtPracticeSite } from '../../../actions/appointmentActions';

import { useAppDispatch, useAppSelector } from '../../../store';

import '../css/calendarScheduleFilters.css'

interface Services {
    id: number,
    name: string
}

function CalendarScheduleFilters(props: any) {

    const {
        results,
        setCriteria,
        onCalendarScheduleSearch,
        setCalendarId,

    }: {
        results: any,
        setCriteria: Function,
        onCalendarScheduleSearch: Function,
        setCalendarId: Function,
    } = props

    
    const practiceSites = useAppSelector((state) => state.appointment.practiceSites);

    const defaultOption = { id: 0, name: 'Select an option' }

    const [selectedPracticeSiteId, setSelectedPracticeSiteId] = useState<number>(0);
    const [selectedServiceSiteId, setSelectedServiceSiteId] = useState<number>(0);
    const [isServicesLoaded, setIsServicesLoaded] = useState<boolean>(true);
    const [serviceList, setServiceList] = useState<Services[]>([]);
    const [isSearching, setIsSearching] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    const onSiteChange = async (e: any) => {
        setSelectedPracticeSiteId(e.target.value);
        setSelectedServiceSiteId(0);
        if (e.target.value !== "0") {
            setIsServicesLoaded(false);
            await dispatch(getServicesForReferralSiteAtPracticeSite(e.target.value))
                .then((response: any) => {
                    if (!response.error) {
                        setServiceList([
                            defaultOption,
                            ...response.payload?.data.map((item: any) => ({
                                id: item.serviceSiteId,
                                name: item.name
                            }))
                        ]);
                    }
                    setIsServicesLoaded(true);
                })
        }
        else {
            setServiceList([defaultOption]);
            setSelectedServiceSiteId(0);
        }
    }

    const onServiceChange = (e: any) => {
        setSelectedServiceSiteId(e.target.value);
		setCalendarId(e.target.value);
    }

    const handleSearch = (e: any) => {
        e.preventDefault();
        setIsSearching(true);
        onCalendarScheduleSearch(Number(selectedServiceSiteId));
    }

    useEffect(() => {
        if (isSearching) {
            setIsSearching(!(results?.data));
        }
    }, [results]);

    return (
        <>
            <ActiveErrors />
            <div className='col-lg-12 calendarScheduleFilterContent'>
                <Form onSubmit={handleSearch}>
                    <div className='row'>
                        <div className='col-3'>
                            <DropdownSelectWithLabel
                                id='selectedSite'
                                isRequired
                                label='Practice Site'
                                onChange={(e: any) => onSiteChange(e)}
                                optionList={practiceSites}
                                value={selectedPracticeSiteId} />
                        </div>
                        <div className='col-3'>
                            <DropdownSelectWithLabel
                                id='selectedService'
                                isRequired
                                label='Service'
                                onChange={(e: any) => onServiceChange(e)}
                                optionList={serviceList}
                                value={selectedServiceSiteId} />
                        </div>
                        <div className='col-2 calendarScheduleSearchButton'>
                            {!isServicesLoaded && <FontAwesomeIcon icon='spinner' spin />}
                            <Button color='primary' style={{ marginLeft: '5px' }} disabled={!selectedPracticeSiteId || selectedPracticeSiteId == 0 || !selectedServiceSiteId || selectedServiceSiteId == 0 || isSearching} type='submit'>
                                {isSearching ? (
                                    <span>
                                        <FontAwesomeIcon icon='spinner' spin /> Searching...
                                    </span>
                                ) : (
                                    <span>Search</span>
                                )}
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        </>
    )
}

export default CalendarScheduleFilters;